<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
        <sm-form #form [form]="formInput">
        </sm-form>
        <p-button class="mt-2" icon="fas fa-search" label="Starten" (onClick)="run()"></p-button>
    </p-panel>
    <sm-table2 #table *ngIf="tableData != null" class="flex-item-fill height100p" [data]="tableData"></sm-table2>
</div>
